import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ChangeOrderCustomerInput } from './ChangeOrderCustomerInput';
import { ChangeOrderCustomerOutput } from './ChangeOrderCustomerOutput';

export class ChangeOrderCustomerService extends HttpServiceBase {

  handle = (input: ChangeOrderCustomerInput): Promise<Result<ChangeOrderCustomerOutput> | null> => {
    const promise = this.http.put<Result<ChangeOrderCustomerOutput>, ChangeOrderCustomerInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/change-customer`,
      input
    );
    return promise;
  }
}